import { render, staticRenderFns } from "./stage-list.vue?vue&type=template&id=6afca374&scoped=true&"
import script from "./stage-list.vue?vue&type=script&lang=js&"
export * from "./stage-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afca374",
  null
  
)

export default component.exports